<script>
import { mapGetters } from "vuex";

export default {
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },

    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch("auth/logOut", {}).then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
  computed: {
    ...mapGetters("auth", ["userDetails"]),
    ...mapGetters("utils", ["getIndustryName", "getIndustryImage"]),
    getCurrentUsername() {
      return this.userDetails && this.userDetails.user.username;
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-light.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <!-- <img src="@/assets/images/logo-light.png" alt height="19" /> -->

              <img
                :src="getIndustryImage"
                :alt="getIndustryName"
                height="75px"
                width="auto"
              />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block">
          <!-- <div class="position-relative">
            <input
              type="text"
              class="form-control"
              :placeholder="$t('navbar.search.text')"
            />
            <span class="bx bx-search-alt"></span>
          </div> -->
        </form>
      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Αναζήτηση..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <span class="d-none d-xl-inline-block ms-1">
              <div>{{ getCurrentUsername }}</div>
            </span>
            <i class="bx bx-user-circle font-size-16 align-middle me-1"></i>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <b-dropdown-item>
            <router-link to="/contacts/profile" v-slot="{ navigate }" custom>
              <span @click="navigate" @keypress.enter="navigate">
                <i class="bx bx-user font-size-16 align-middle me-1"></i>
                {{ $t("navbar.dropdown.henry.list.profile") }}
              </span>
            </router-link>
          </b-dropdown-item>

          <!-- <b-dropdown-item>
            <router-link
              to="/contacts/authentication-passsword"
              v-slot="{ navigate }"
              custom
            >
              <span @click="navigate" @keypress.enter="navigate">
                <i class="bx bx-wrench font-size-16 align-middle me-1"></i>
                {{ $t("navbar.dropdown.henry.list.settings") }}
              </span>
            </router-link> -->
          <!-- class="d-block"
            href="/contacts/authentication-passsword"
          > -->

          <!-- <i class="bx bx-wrench font-size-16 align-middle me-1"></i>
            {{ $t("navbar.dropdown.henry.list.settings") }} -->
          <!-- </b-dropdown-item> -->

          <b-dropdown-divider></b-dropdown-divider>
          <button class="dropdown-item text-danger" @click.prevent="logoutUser">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </button>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
